var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v(" The page located at "+_vm._s(this.$route.path)+" does not exist. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }